import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-display-errors',
  imports: [],
  templateUrl: './display-errors.component.html',
  styleUrl: './display-errors.component.scss',
})
export class DisplayErrorsComponent {
  @Input() errors: string[] = [];
}